import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../lib/axios";

import type { Organization } from "../types/organization";

const ORGANIZATIONS_ROUTE = "/organizations/all";

interface OrganizationsResponse {
  organizations: Organization[];
}

export const useOrganizations = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["organizations"],
    queryFn: async () => {
      const response =
        await axiosInstance.get<OrganizationsResponse>(ORGANIZATIONS_ROUTE);
      return response.data.organizations;
    },
    enabled: options?.enabled,
  });
};
